import * as React from "react"

const SvgButton = (props) => (
<svg width="24" height="12" viewBox="0 0 24 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M22 0H2C0.89543 0 0 1 0 2V10C0 11 0.89543 12 2 12H22C23.1046 12 24 11 24 10V2C24 1 23.1046 0 22 0Z" fill="#191936"/>
</svg>
)

export default SvgButton
